import React, { useEffect, useState, useReducer, useMemo } from 'react';
import {
    Nav,
    Navbar,
    NavbarBrand,
    Collapse,
    DropdownItem,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    Badge,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    UncontrolledTooltip,
} from 'reactstrap';
import profilephoto from '../../assets/images/users/profile-img.png';

import logohesaab from '../../assets/images/logo.svg';
import { Link, useHistory } from 'react-router-dom';
import { useClient, useUserContext } from "../../hooks";
import { LanguageSwitcher } from "components";
import { Trans, useTranslation } from "react-i18next";
import { useOrganisationContext } from "../../hooks/useOrganisationContext";
import SelectOrganisation from './SelectOrganisation';
import { formatDateTime } from 'services/util'
import featureUpdateImage from "../../assets/images/announce-product-updates-features.jpg";

import ConnectToXero from 'pages/ConnectToXero';

import { useTips } from 'components/Tips/TipContext';
import { NotificationManager } from 'react-notifications';

const modalReducer = (state, action) => {
    switch (action.type) {
        case "SHOW_MODAL":
            return { ...state, isModalVisible: true };
        case "HIDE_MODAL":
            return { ...state, isModalVisible: false };
        default:
            return state;
    }
};

const Header = () => {
    const { resetTips } = useTips();

    const { user, query, isInTrialPeriod, isAdmin, isAuthenticated, } = useUserContext();
    const client = useClient();
    const { selectedOrganisation, organisations } = useOrganisationContext();
    const history = useHistory();

    const { t, i18n } = useTranslation();
    const dir = i18n.dir();
    function handleImageClick() {
        history.push('/home');
    }

    const userPicture = user?.user_picture !== null ? '/api' + user.user_picture : undefined;

    const showMobilemenu = () => {
        document.getElementById('main-wrapper').classList.toggle('show-sidebar');
    }
    const initialState = {
        isModalVisible: false,
    };
    const [state, dispatch] = useReducer(modalReducer, initialState);



    const closeModal = () => {
        dispatch({ type: "HIDE_MODAL" });
        readNotification(announcementData[0])
    };


    const { hesaablanguage } = selectedOrganisation?.subscribed_features || {}
    const [languageOptions, setLanguageOptions] = useState([])
    const [notifications, setNotifications] = useState([])
    const [filteredLanguageOptions, setFilteredLanguageOptions] = useState([])


    const [notification, setNotification] = useState({})
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => setIsOpen(!isOpen);
    const [isGuideOpen, setIsGuideOpen] = useState(false);

    const purgeCache = () => {
        client.post(`xero_actions/${selectedOrganisation.id}/purge_cache`).then((res) => {
            NotificationManager.success(t("Done Successfully"));
            window.location.reload();
        }).catch((err) => { })

    }

    const readNotification = (item) => {
        try {
            let id = item?.id

            let notificationEndpoint = null

            if (isAdmin) {
                notificationEndpoint = `/superuser-notifications/${id}/read`
            } else {
                if (!selectedOrganisation?.id) return;
                notificationEndpoint = `/${selectedOrganisation?.id}/user-notifications/${id}/read`
            }

            client.get(notificationEndpoint).then((res) => {
                setNotification(res.data)
                toggle()
                fetchNotifications()
            })

        } catch (error) {
            console.error("Error fetching notifications:", error);
        }
    }

    const fetchNotifications = async () => {
        try {
            let notificationEndpoint = null

            if (isAdmin) {
                notificationEndpoint = `/superuser-notifications`
            } else {
                if (!selectedOrganisation?.id) return;
                notificationEndpoint = `/${selectedOrganisation?.id}/user-notifications`
            }

            client.get(notificationEndpoint).then((res) => {
                setNotifications(res.data);
            })
        } catch (error) {
            console.error("Error fetching notifications:", error);
        }
    };

    useEffect(() => {
        client.get('core/hesaab_language').then((res) => {
            const allLanguages = res?.data || []
            setLanguageOptions(allLanguages.map(item => ({ value: item.id, code: item.code, label: item.name })))
        })

        let interval = null

        if (isAuthenticated) {
            fetchNotifications()

            // Set up the interval to fetch notifications every 10 minutes
            let oneSec = 1000
            interval = setInterval(fetchNotifications, oneSec * 60 * 10);

            window.addEventListener('online', () => {
                interval = setInterval(fetchNotifications, oneSec * 60 * 10);
            });

            window.addEventListener('offline', () => {
                if (interval) {
                    clearInterval(interval)
                }
            });
        }

        // Cleanup interval on component unmount
        return () => {
            if (interval) {
                clearInterval(interval)
            }

            setNotifications([])
            setLanguageOptions([])
        }
    }, [])

    useEffect(() => {
        if (isAuthenticated && !isAdmin) {
            setFilteredLanguageOptions(languageOptions.filter(item => hesaablanguage?.includes(item.code) || isInTrialPeriod))
        } else {
            setFilteredLanguageOptions(languageOptions)
        }

    }, [hesaablanguage, languageOptions])


    const [showMenu, setShowMenu] = useState(false);
    const toggleDropdown = () => setShowMenu(prevState => !prevState);
    const [showNotif, setNotifShow] = useState(false);
    const toggleNotif = () => setNotifShow(prevState => !prevState);

    const handleLogout = async (e) => {
        e.preventDefault();
        await client.post("logout");
        localStorage.clear();
        //await query.refetch();
        //history.push('/login');
        window.location.href = '/login';
    };

    const toProfile = async (e) => {
        e.preventDefault();
        history.push('/profile');
    };
    const announcementData = useMemo(() => {
        return notifications?.items?.filter((item) => item.type === "Announcement" && !item.is_read) || [];
    }, [notifications?.items]);

    useEffect(() => {
        if (!user?.id || announcementData.length === 0 || user?.is_superuser) return;

        if (user.role === "Subscriber" || user.role === "User") {
            if (announcementData?.length > 0) {
                dispatch({ type: "SHOW_MODAL" });
            }
        }
    }, [user?.id, announcementData]);

    const isLive = selectedOrganisation?.status === "LIVE";

    // Hard-coded, self-expiring banner for the ZATCA FATOORA Platform scheduled maintenance:
    // Friday, August 7, 2026, 3:00 AM - 11:00 AM (Asia/Riyadh, UTC+3) => 00:00 - 08:00 UTC.
    // Only relevant to Saudi (ZATCA-onboarded) organisations.
    const isZatcaSubscribed = selectedOrganisation?.onboarding_date || true;
    const showZatcaMaintenanceAlert = useMemo(() => {
        if (!isZatcaSubscribed) return false;
        const now = new Date();
        const start = new Date(Date.UTC(2026, 7, 7, 0, 0, 0));
        const end = new Date(Date.UTC(2026, 7, 7, 8, 0, 0));
        return now >= start && now <= end;
    }, [isZatcaSubscribed]);

    return (
        <header className="topbar navbarbg side-br px-2">
            {showZatcaMaintenanceAlert && <div style={{ position: 'fixed', top: 64, left: 250, right: 50, zIndex: 1050 }}>
                <div className='alert alert-warning mb-0 py-1 text-truncate'>
                    <strong><Trans>Note:</Trans></strong> <Trans>ZATCA is under maintenance until 11 AM. Invoices will resume automatically.</Trans>
                </div>
            </div>}
            <Navbar className="top-navbar" dark expand="lg">
                <div className="navbar-header" id="logobg" data-logobg="skin6">
                    <NavbarBrand>
                        <img
                            src={logohesaab}
                            alt="#"
                            width={80}
                            onClick={handleImageClick}
                            style={{ cursor: 'pointer' }}
                        />
                    </NavbarBrand>
                    {/* <button className="btn-link nav-toggler d-block d-md-none" onClick={() => showMobilemenu()}>
                        <i className="ti-menu ti-close" />
                    </button> */}
                </div>
                <Collapse navbar
                    className={`
                        navbarbg
                        ${dir == "rtl" ? "fix-rtl" : ""}
                    `}
                >
                    <div className="container">
                        <h4 style={{ fontSize: '18', fontStyle: 'normal', fontWeight: '600' }}><Trans>Welcome back to new and updated Hesaab</Trans></h4>
                    </div>
                    <Button color="link" className="text-muted px-1 mx-2" onClick={purgeCache} id="purgeCache">
                        <i className="fa fa-refresh" aria-hidden="true" />
                        <UncontrolledTooltip placement="bottom" target={"purgeCache"}>
                            <Trans>Hard Refresh, if data is not updating from xero please click here</Trans>
                        </UncontrolledTooltip>
                    </Button>
                    {!isAdmin && <>

                        <SelectOrganisation organisations={organisations} selectedOrganisation={selectedOrganisation} userGroup={user.groups[0].name} />
                        <div className="mr-1" style={{ fontSize: "1.1em" }}>
                            {isLive ?
                                <i className="fa fa-sign-out-alt text-success" />
                                :
                                <i className="fa fa-sign-in-alt text-danger" />
                            }
                        </div>

                    </>
                    }

                    <a href="https://go.xero.com/app/dashboard" target="_blank" rel="noopener noreferrer">
                        <img
                            src="/images/xeroDot.png"
                            width="55"
                            alt="Xero Logo"
                            style={{ cursor: 'pointer' }}
                        />
                    </a>
                    <div className="mr-2" />
                    <LanguageSwitcher
                        isInTrialPeriod={isInTrialPeriod}
                        isAuthenticated={isAuthenticated}
                        isAdmin={isAdmin}
                        languageOptions={filteredLanguageOptions}
                        subscribedLanguages={hesaablanguage || []}
                    />
                    <Nav className="d-flex align-items-center ml-auto float-right profile-drp" navbar>
                        <Dropdown nav inNavbar isOpen={showNotif} toggle={toggleNotif} className="custom-dropdown">
                            <DropdownToggle nav>
                                <div className="text-nowrap notif-icon-wrapper">
                                    <i className='fa fa-bell' />
                                    {notifications?.count && notifications?.count > 0 ? <Badge color="danger" className="notif-badge">
                                        {notifications?.count > 99 ? "99+" : notifications?.count}
                                    </Badge> : ''}
                                </div>
                            </DropdownToggle>
                            <DropdownMenu className="notify-drop py-0" right>
                                <div className="notify-drop-title">
                                    <div className="row">
                                        <div className="col-md-6 col-sm-6 col-xs-6"><Trans>Notifications</Trans> {notifications?.count && notifications?.count > 0 ? <b>{`(${notifications?.count})`}</b> : ''}</div>
                                        {/* <div className="col-md-6 col-sm-6 col-xs-6 text-right"><a href="#" className="rIcon allRead" data-tooltip="tooltip" data-placement="bottom" title="Read all"><i className="fa fa-dot-circle"></i></a></div> */}
                                    </div>
                                </div>
                                <div className="drop-content">
                                    {notifications && notifications?.items?.map((item) => (
                                        <li className={`notify-drop-item ${!item.is_read ? 'unread' : ''}`} style={{ cursor: "pointer" }} key={item.id} onClick={() => readNotification(item)}>
                                            <div className="row">
                                                <div className="col-md-12 col-sm-12 col-xs-12">
                                                    {
                                                        item.is_read ? <i className="fa fa-envelope-open notif-icon" /> : <i className="fa fa-envelope notif-icon" />
                                                    }

                                                    <h5 className="title">{item.title}</h5>
                                                    <p className="message">{item.message}</p>
                                                    <hr />
                                                    <p className="time" title={formatDateTime(item.created_at)}><i className="fa fa-clock-o"></i> {item.time_since_created}</p>

                                                </div>
                                            </div>
                                        </li>
                                    )
                                    )}
                                </div>
                                {/* <div className="notify-drop-footer text-center">
                                    <a href="#" onClick={(e) => { e.preventDefault(); alert("See all"); }}><i className="fa fa-eye"></i> See all</a>
                                </div> */}

                            </DropdownMenu>
                        </Dropdown>

                    </Nav>
                    <Nav className="d-flex align-items-center ml-auto float-right profile-drp" navbar>
                        {/* <UncontrolledDropdown nav inNavbar> */}
                        <Dropdown nav inNavbar isOpen={showMenu} toggle={toggleDropdown}>

                            <DropdownToggle nav caret className="pro-pic">
                                <img
                                    src={userPicture || profilephoto}
                                    alt="user"
                                    //style={{display: "inline-block", position: "relative", width: "200px", height: "200px", overflow: "hidden", borderRadius: "50%" }}
                                    style={{ borderRadius: '50%', width: 30, height: 30 }}
                                />
                            </DropdownToggle>
                            <DropdownMenu right className="user-dd py-0">

                                <DropdownItem onClick={(e) => toProfile(e)} style={{ cursor: "pointer" }}>
                                    <div className="text-left w-100 d-inline-block">
                                        <i className="mr-1 ml-1" /><Trans>Profile Page</Trans>
                                    </div>
                                </DropdownItem>
                                {user?.groups && user?.groups[0].name === "Superadmin" && <DropdownItem onClick={(e) => setIsGuideOpen(true)} style={{ cursor: "pointer" }}>
                                    <div className="text-left w-100 d-inline-block">
                                        <i className="mr-1 ml-1" /><Trans>Connect to Xero guide</Trans>
                                    </div>
                                </DropdownItem>}

                                {user?.groups && user?.groups[0].name === "Superadmin" && <DropdownItem onClick={() => resetTips()} style={{ cursor: "pointer" }}>
                                    <div className="text-left w-100 d-inline-block">
                                        <i className="mr-1 ml-1" /><Trans>Xero Connect Tips</Trans>
                                    </div>
                                </DropdownItem>
                                }

                                <DropdownItem onClick={(e) => handleLogout(e)} style={{ cursor: "pointer" }}>
                                    <div className="text-left w-100 d-inline-block logout-item">
                                        <i className="fa fa-power-off mr-1 ml-1" /><Trans>Logout</Trans>
                                    </div>
                                </DropdownItem>

                                {/* <Link  color='success' className="ml-3 mb-2 mt-2 switch-btn"
                                    
                                    to="/v2/dashboard2"
                                    >
                                     Switch to Hr Personnel 
                                  </Link> */}

                            </DropdownMenu>
                        </Dropdown>
                        <div className='userInfo' onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "rgb(247, 248, 249)"; }} onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = ""; }}>
                            <Link to="#" onClick={() => toggleDropdown()}>
                                <span className='text-nowrap' style={{
                                    fontWeight: '700',
                                    fontSize: '14px', color: '#121127'
                                }}>{user.first_name}</span><br />
                                <span className="d-block" style={{ position: 'relative', bottom: '8px' }}>{user.email}</span>
                            </Link>
                        </div>
                    </Nav>
                </Collapse>
            </Navbar>

            <Modal isOpen={isOpen} toggle={toggle}>
                <ModalHeader>
                    <Trans>Notifications</Trans>
                </ModalHeader>
                <ModalBody>
                    <h5><Trans>{notification.title}</Trans></h5>
                    <p>
                        <Trans>
                            {notification.message}
                        </Trans>
                    </p>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>
                        <Trans>Close</Trans>
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={state.isModalVisible} toggle={closeModal}>

                <ModalHeader toggle={closeModal} className="text-center border-0 py-1">
                </ModalHeader>
                <ModalBody className="text-center">
                    <img style={{ width: "310px", height: "150px" }} src={featureUpdateImage} alt="Celebration Illustration" className="img-fluid mb-3" />
                    <h4 className="font-weight-bold mb-3"><Trans>{announcementData[0]?.title}</Trans></h4>
                    <p>
                        <Trans>
                            {announcementData[0]?.message}
                        </Trans>
                    </p>
                    <Button color="primary" className="mt-4">
                        <Trans>Ready to try it out?</Trans>
                    </Button>
                </ModalBody>
            </Modal>

            {user?.groups && user?.groups[0].name === "Superadmin" && <ConnectToXero isGuideOpen={isGuideOpen} setToggle={setIsGuideOpen} t={t} isLive={isLive} user={user} />}
        </header>
    );
}
export default Header;
